import { select } from 'd3-selection'
import { savedJQuery } from './components/jquery'
import { unsetPageHasChanges } from './page-has-changes'

/**
 * This sign button is displayed in pop-up window when
 * sign button on daily log page is clicked
 */
export function initSign () {
  select('#sign2')
    .onclick(sign)
}

export function sign () {
  hideButtonAndDisplayLoader()
  let form = getForm()
  savedJQuery(window).off()
  unsetPageHasChanges()
  form.submit()
}

function hideButtonAndDisplayLoader () {
  let button = document.getElementById('sign2')
  button.style.display = 'none'
  /** @type {HTMLDivElement} */
  // @ts-ignore
  let loader = button.parentElement.getElementsByClassName('loader')[0]
  loader.style.visibility = 'visible'
}

function getForm () {
  /** @type {HTMLFormElement} */
  // @ts-ignore
  let form = document.getElementById('page-data-form')
  appendSignatureInput(form)
  appendMechanizationInputs(form)
  return form
}

/**
 * @param {HTMLElement} form 
 */
function appendSignatureInput (form) {
  let input = document.createElement('input')
  input.setAttribute('type', 'hidden')
  input.setAttribute('name', 'is_signed')
  input.setAttribute('value', '1')
  form.appendChild(input)
}

/**
 * Appends two empty mechanizations fields to form as
 * we deleted those two from page, but didn't delete from database
 * so server requires three mechanization fields
 * @param {HTMLElement} form 
 */
function appendMechanizationInputs (form) {
  for (let i = 0; i < 2; ++i) {
    let input = document.createElement('input')
    input.setAttribute('type', 'hidden')
    input.setAttribute('name', 'mechanization[]')
    input.setAttribute('value', 'blank mechanization')
    form.appendChild(input)
  }
}